import { getEnvType } from "../Networking/NetworkingUtils"

export function blobDomain() {
    if (getEnvType() === "prod") {
        return 'https://drstorageprod-fd-hcezh5aya8brbwg6.a01.azurefd.net/'
    }else if (getEnvType() === "qa") {
        return 'https://bbverseblobhackathon-fxbga9fubtg7djcw.z01.azurefd.net/'
    }
    return 'https://bbverseblobdev-hmgaeqaud0ekgrcs.z01.azurefd.net/'
}

export function blobNoCacheDomain() {
    if (getEnvType() === "prod") {
        return 'https://drstorageprod.blob.core.windows.net/'
    } else if (getEnvType() === "qa") {
        return 'https://bbverseblobhackathon.blob.core.windows.net/'
    }
    return "https://bbverseblobdev.blob.core.windows.net/"
}

export function blobSAS() {
    if (getEnvType() === "prod") {
        return 'sv=2022-11-02&ss=bfqt&srt=co&sp=rtfx&se=2025-06-29T19:03:48Z&st=2025-01-23T11:03:48Z&spr=https&sig=%2B%2Fj2%2FWw20SQRTSYv43cvsBIxWL0HfkgndU26SrGEC2k%3D'
    } else if (getEnvType() === "qa") {
        return 'sv=2024-11-04&ss=bfqt&srt=o&sp=rtfx&se=2026-01-06T23:30:23Z&st=2025-09-08T15:15:23Z&spr=https&sig=I3RbhXTwQBasDhv9jMJM3H4CNh%2FeF3T5VTHwwnXqlJA%3D'
    }
    return 'sv=2022-11-02&ss=bf&srt=o&sp=r&se=2024-12-30T20:23:58Z&st=2024-08-13T12:23:58Z&spr=https,http&sig=RwUwkAi71F4xJdZhNMVeO67QcFbRgdx%2Fav2szOYIjyE%3D'
}

export function blobWriteString() {
    if (getEnvType() === "prod") {
        return blobNoCacheDomain() + '?sv=2022-11-02&ss=bfqt&srt=co&sp=rwdlacupitfx&se=2025-06-29T19:03:48Z&st=2025-01-23T11:03:48Z&spr=https&sig=YE5XZW8mzbgPdGYm0p4yH01GhLBo9chDYEdZcLSxfqQ%3D'
    } else if (getEnvType() === "qa") {
        return blobNoCacheDomain() + '?sv=2024-11-04&ss=bfqt&srt=o&sp=rwdlacupiytfx&se=2026-01-06T23:30:23Z&st=2025-09-08T15:15:23Z&spr=https&sig=ltw8L74hNfZj35v2eZIsbSwCiaDuW8rymHqPJtkCmCQ%3D'
    }
    return blobNoCacheDomain() + "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-12-30T20:16:39Z&st=2024-04-01T01:16:39Z&spr=https,http&sig=6VKWJm1Pett7HzmIz%2Fh7Q8%2FFR%2F6k1A8VMwuC7vAyu6s%3D"
}

export function handleCacheControl(url) {

    if (url.match(/\.wasm/) || url.match(/\.data/) || url.match(/\.bundle/)) {

        // return "must-revalidate";
        return 'immutable'

    }

    if (url.match(/\.mp4/) || url.match(/\.wav/)) {

        return "immutable";

    }

    return "no-store";

}

export function blobServiceClientFunc() {
    if (getEnvType() === "prod") {
        return blobServiceClientFuncForPROD()
    } else if (getEnvType() === "qa") {
        return blobServiceClientForDEV()
    } else {
        return blobServiceClientFuncForDev()
    }
}

// function blobServiceClientFuncForQA() {
//     const { BlobServiceClient } = require("@azure/storage-blob");
//     const { InteractiveBrowserCredential } = require("@azure/identity");
//     window.Buffer = require("buffer").Buffer;

//     const blobSasUrl = blobWriteString()

//     const blobServiceClient = new BlobServiceClient(blobSasUrl, new InteractiveBrowserCredential(
//         {
//             tenantId: "a04222fe-0c5c-40bb-8420-97a219ba514e",
//             clientId: "64073365-5a03-4736-b34e-597376266a0c"
//         }
//     ));
//     return blobServiceClient
// }

function blobServiceClientFuncForDev() {
    const { BlobServiceClient } = require("@azure/storage-blob");
    const { InteractiveBrowserCredential } = require("@azure/identity");
    window.Buffer = require("buffer").Buffer;

    const blobSasUrl = blobWriteString()

    const blobServiceClient = new BlobServiceClient(blobSasUrl, new InteractiveBrowserCredential(
        {
            tenantId: "a04222fe-0c5c-40bb-8420-97a219ba514e",
            clientId: "64073365-5a03-4736-b34e-597376266a0c"
        }
    ));
    return blobServiceClient
}

function blobServiceClientFuncForPROD() {
    const { BlobServiceClient } = require("@azure/storage-blob");
    window.Buffer = require("buffer").Buffer;

    const blobSasUrl = blobWriteString()

    const blobServiceClient = new BlobServiceClient(blobSasUrl);
    return blobServiceClient
}

export function blobServiceClientForDEV() {
    const { BlobServiceClient } = require("@azure/storage-blob");
    window.Buffer = require("buffer").Buffer;

    const blobSasUrl = blobWriteString()

    const blobServiceClient = new BlobServiceClient(blobSasUrl);
    return blobServiceClient
}